<template>
    <div class="classSoftware">
        <el-dialog title="提点建议" :close-on-click-modal='false' :visible.sync="isForget" width="800px" :modal="true" v-dialogDrag
        @close="handleSuggestionClose">
            <el-form class="suggestion-form" ref="suggestion_form" :model="suggestion_form" label-width="80px" :rules="suggestion_rules">
                <el-form-item label="标题" prop="title">
                    <label style="width:8px;height:8px;position:absolute;background-color:red;left:-55px;border-radius:10px;top:15px;"></label>
                    <el-input v-model="suggestion_form.title"></el-input>
                </el-form-item>
                <el-form-item label="标签" prop="label">
                    <el-radio-group v-model="suggestion_form.label">
                        <el-radio v-for="item in labelOptions" :key="item.id" :label="item.dictValue" border>{{item.dictValue}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="内容" style="height:230px;" prop="content">
                    <el-input type="textarea" v-model="suggestion_form.content" :rows="10" :maxlength="500" @input="descInput"></el-input>
                    <span style="position:relative;top:-40px;left:48%;font-size:12px;color:#d2d2d2;">{{remain}}/500</span>
                </el-form-item>
                <el-form-item label="上传图片">
                    <p class="pic-info">（您还可以上传点图片，便于我们更准确的理解您的建议）</p>
                    <div class="upload-img-box">
                        <img v-for="item in imageUrl" :key="item" :src="item" class="upload-img" />
                        <el-upload :action="uploadPhoto()" :show-file-list="false"  :on-success="handleImgSuccess" :before-upload="beforeImgUpload">
                            <img v-if="imageUrl.length < 3 " src="../../../../assets/upload-pic.png" class="upload-img" />
                        </el-upload>

                    </div>
                </el-form-item>
                <!-- <div>
                    <span style="font-size:16px;line-height:16px;margin:0;margin-left:10px;display:inline-block">感谢您的建议，需要收到我们的回复吗？</span>
                    <el-checkbox v-model="suggestion_form.needReply" style="line-height:16px;" label="需要">需要</el-checkbox>
                </div> -->
                <div style="padding-top:25px;text-align:center;border-top:1px #e5e5e5 solid;margin-top:15px;  ">
                    <el-button type="primary" class="btn-submit" @click="submitSuggestion">提交</el-button>
                </div>
            </el-form>
        </el-dialog>

        <el-dialog title="开始学习"  :close-on-click-modal='false' :visible.sync="startStudy" width="500px" height="310px" :modal="false" v-dialogDrag>
            <learning-system v-if="startStudy" :url="'learningSystem://'+encodeURIComponent(url)"></learning-system>
        </el-dialog>
        <el-dialog title="温馨提示"  :close-on-click-modal='false' :visible.sync="canStudy" v-if="canStudy" width="500px" height="310px" :modal="false">
            <div>
                <p style="color:#666666">您当前还未学满对应的课程学时，还需完成以下学习时长</p>
                <template v-for="(f,i) in unfinishedList">
                  <p v-if="f.time>0" :key="i">{{f.name}} 还需学习 {{caculateTime2(f.time,2)}}</p>
                </template>
            </div>
        </el-dialog>

        <el-dialog
            title="学习笔记"
            :close-on-click-modal='false'
            :visible.sync="studyNote"
            width="800px"
            :modal="true"
            :lock-scroll="true"
            class="study-note"
            v-dialogDrag
            @close="handleNoteClose">
            <div>
                <div style="position:relative">
                    <p
                        style="font-size:16px;color:#333333;margin:0;padding:7px 15px;background-color:#eeeeee;border-radius:20px;max-width:850px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:center;position:absolute;top:-18px;left:20px;z-index:2000"
                    >{{currentCourseName}}</p>
                </div>
                <div style="height:500px;overflow:auto;width:760px;magin:0 auto;border:1px #eeeeee solid;">
                    <el-checkbox-group v-model="deleteList" class="delete-list">
                        <el-checkbox :label="item.id" v-for="(item) in studyNoteList" :key="item.id" style="margin-left:20px;position:relative;">
                            <p style="font-size:14px;color:#999999;">
                                <span>{{item.createTime.slice(0,4)+'.'+item.createTime.slice(5,7)+'.'+item.createTime.slice(8,10)}}</span>
                                <span style="margin-left:15px;">章节：{{item.aaa || item.levelName}}</span>
                            </p>
                            <p class="note-background">
                                <span style="width:600px;word-break: break-all;white-space:normal;display:inline-block;">{{item.content}}</span>
                            </p>
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
                <el-pagination
                    style="float: right; margin: 20px 0px 10px;"
                    :page-size="noteInfo.pageSize"
                    :pager-count="noteInfo.pagerNum"
                    layout="prev, pager, next"
                    @current-change="currentChangeCtudyNote"
                    :total="noteInfo.total">
                </el-pagination>
                <div style="margin-top:30px;" class="studynote-bottom">
                    <el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                    <el-button type="info" plain @click="deleteStudyNote">删除</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog
            :title="recordTitle + '记录'"
            :visible.sync="studyRecord"
            width="1000px"
            :modal="true"
            :lock-scroll="true"
            class="study-record"
            @close="closeStudyNote"
            v-dialogDrag
            :close-on-click-modal='false'
        >
            <div>
                <div style="position:relative">
                    <p
                        style="font-size:16px;color:#333333;margin:0;padding:7px 15px;background-color:#eeeeee;border-radius:20px;max-width:850px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:center;position:absolute;top:-18px;left:20px;z-index:2000"
                    >{{currentCourseName}}</p>
                </div>

                <div style="height:500px;overflow-x:hidden;width:950px;magin:0 auto;border:1px #eeeeee solid;position:relative;margin-top:20px;">
                    <div class="list-wrap">
                        <div v-for="(item , index) in recordList" :key="item.id">
                        <div>
                            <div style="border-bottom:1px solid #e5e5e5;" class="course-wrap">
                                <p class="study-time">{{item.createTime ? item.createTime.substring(0,10) : ""}}</p>
                                <div class="study-long">
                                    <p class="record-middle">
                                        {{recordTitle}}总时长：{{caculateTime1(item.chapterStudyTime,1)}}
                                        <!-- <span style="margin-left:60px;">学习进度</span>
                                        <el-progress
                                            :stroke-width="12"
                                            :show-text="false"
                                            :percentage="progress(item.hadLearn,currentCourseCount)"
                                            style="display:inline;"
                                        ></el-progress> -->
                                    </p>
                                </div>
                                <div class="last-study">最近{{recordTitle}}：{{item.sectionName}}</div>
                                <div
                                    class="study-detail"
                                    @click="changeRecord(index,item.courseId,item.createTime,item.seatMealCourseId)"
                                >
                                    <span v-if="showRecord[index]">
                                        <i class="el-icon-arrow-up"></i>收起详情
                                    </span>
                                    <span v-if="!showRecord[index]">
                                        <i class="el-icon-arrow-down"></i>展开详情
                                    </span>
                                </div>
                                <div style="clear:both;"></div>
                            </div>
                            <!-- 学习记录下拉菜单 -->
                            <el-collapse-transition>
                                <div v-if="showRecord[index]" style="margin-bottom:40px;padding-left:10px;">
                                    <div style="height:40px;line-height:40px;display:table;" v-for="(subRecord) in subRecordList[index]" :key="subRecord.id">
                                        <div class="record-detail">
                                            <div class="create-time">{{subRecord.createTime ? subRecord.createTime.substring(11,16) : ''}}</div>
                                            <div class="study-time">时长：{{caculateTime1(subRecord.chapterStudyTime,1)}}</div>
                                            <el-tooltip effect="light" placement="right" :content="subRecord.sectionName">
                                                <div class="section-name nowrap-one">章节：{{subRecord.sectionName}}</div>
                                            </el-tooltip>
                                        </div>
                                    </div>
                                </div>
                            </el-collapse-transition>
                        </div>
                    </div>
                    </div>
                </div>
                <div style="margin-top:30px;text-align:center" class="studynote-bottom">
                    <el-pagination
                        style="float:right;margin:20px 0 10px 0;"
                        @size-change="handleRecordSizeChange"
                        @current-change="handleRecordChange"
                        :current-page="recordPage.pageNum"
                        :page-sizes="[10, 3]"
                        :page-size="recordPage.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="recordPage.total"
                    ></el-pagination>
                </div>
            </div>
        </el-dialog>

        <el-dialog title="提示" :close-on-click-modal='false' :visible.sync="tishiShow" width="500px" height="310px" :modal="true" v-dialogDrag :before-close="handleClosetishi">
            <el-form ref="testform" :model="testform" :rules="testformrules" label-width="80px">
                <el-form-item label="执照类型" prop="licenseType" >
                    <el-select v-model="testform.licenseType" placeholder="请选择">
                        <el-option :label="item" :value="item" v-for="item in LicenseCategoryOptions" :key="item"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div style="float:right;margin-bottom:20px">
                    <el-button type="primary" class="btn-submit" @click="submitLicenseCategory">确定</el-button>
                </div>
        </el-dialog>

        <div style="margin-left:40px;margin-right:40px;padding-bottom:40px;" class="contentBox">
            <i class="el-icon-back goBackBtn"  v-show="!isRoutineCourse" @click="$router.go(-1)"  ></i>
            <el-tabs v-model="activeName" @tab-click="handleClick" class="new_tab">
                <el-tab-pane :label="'专业课程（' + tabOneList.length + '个）' " name="one" v-if="tabOneList.length>0">
                    <el-row :gutter="20" style="margin-bottom: 40px;">
                        <el-col
                            :span="8"
                            v-for="item in tabOneList.slice((this.page_number - 1) * this.page_size, this.page_number * this.page_size)"
                            :key="item.id"
                        >
                            <div class="class-panel button-width">
                            <div class="panel-top">
                                <div>
                                <div style="position: relative;">
                                    <img
                                    :src="showImage(item.courseId)"
                                    style="height:145px;width:100%;display:block;"
                                >
                                    <img
                                    src="@/assets/images/courseType1.png"
                                    class="courseTypeImg"
                                >
                                </div>
                                <div class="panel-top-right">
                                    <el-tooltip effect="dark" :content="item.courseName" placement="top-start">
                                    <h2>{{item.courseName}}</h2>
                                    </el-tooltip>
                                    <!-- <p
                                    v-if="item.setmealType==='3'"
                                    >到期时间：{{item.endTime ? item.endTime.substring(0,10) : ""}}</p>
                                    <p
                                    v-if="item.setmealType==='2'"
                                    >到期时间：{{item.endTime ? item.endTime.substring(0,10) : ""}}</p>
                                    <p v-if="item.setmealType==='1'">剩余学时：{{item.availableTime}}</p> -->
                                    <p>最近学习：{{item.sectionName? item.sectionName : '未开始学习'}}</p>
                                    <p style="text-oveflow:clip"
                                    class="study-progress">学习进度：
                                    <el-progress
                                        :show-text="false"
                                        :stroke-width="14"
                                        :percentage="progress(item.studySection,item.countSection)"
                                        style="display:inline-block;top:3px;position:relative;"
                                    ></el-progress>
                                    <span class="pre-number">{{progress(item.studySection,item.countSection)}}%</span>
                                    </p>
                                </div>
                                <div style="clear:both;"></div>
                                <ul style="list-style:none" class="panel-icon">
                                    <li>
                                    <img
                                        src="../../../../assets/icon-panel01.png"
                                        @click="showStudyRecord(item.courseId,item.courseName,item.countSection,item.setmealCourseId, '学习')"
                                        style="cursor:pointer;"
                                    >
                                    <p>学习记录</p>
                                    </li>
                                    <li>
                                    <img
                                        src="../../../../assets/icon-panel02.png"
                                        @click="showStudyNote(item.courseId,item.setmealCourseId,item.courseName)"
                                        style="cursor:pointer;"
                                    >
                                    <p>学习笔记</p>
                                    </li>
                                    <li>
                                    <img
                                        src="../../../../assets/icon-panel03.png"
                                        style="cursor:pointer"
                                        @click="forget(item.courseId)"
                                    >
                                    <p>提点建议</p>
                                    </li>
                                    <div style="clear:both;"></div>
                                </ul>
                                </div>
                            </div>
                            <div class="panel-bottom">
                                <el-button
                                    v-if="trainClassDetail.statuName?trainClassDetail.statu === 2:true"
                                    type="primary"
                                    @click="checkCourseConstraint(item)"
                                >{{ start(item.sectionName) ? '继续学习' : '开始学习'}}</el-button>
                                <el-button type="primary" v-if="trainClassDetail.statuName?trainClassDetail.statu === 1 || trainClassDetail.statu === 3:false" disabled>{{ trainClassDetail.statuName || '已结束' }}</el-button>
                            </div>
                            </div>
                        </el-col>
                    </el-row>
                    <Nothing :show="companyClassInfo"></Nothing>
                    <el-pagination
                        style="float:right;margin:20px 0 10px 0;"
                        @size-change="sizeChange"
                        @current-change="currentChange"
                        :current-page="page_number"
                        :page-sizes="[3, 6]"
                        :page-size="page_size"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="tabOneList.length"
                    ></el-pagination>
                </el-tab-pane>
                <el-tab-pane :label="'专项练习（' + tabTwoList.length + '类）' " name="two" v-if="tabTwoList.length>0">
                    <el-row :gutter="20" style="margin-bottom: 40px;">
                        <el-col
                            :span="8"
                            v-for="item in tabTwoList"
                            :key="item.id"
                        >
                            <div class="class-panel button-width">
                            <div class="panel-top">
                                <div>
                                <div style="position: relative;">
                                    <img
                                    :src="showImage(item.courseId)"
                                    style="height:145px;width:100%;display:block;"
                                >
                                    <img
                                    src="@/assets/images/courseType2.png"
                                    class="courseTypeImg"
                                >
                                </div>
                                <div class="panel-top-right">
                                    <el-tooltip effect="dark" :content="item.courseName" placement="top-start">
                                    <h2>{{item.courseName}}</h2>
                                    </el-tooltip>
                                    <!-- <p
                                    v-if="item.setmealType==='3'"
                                    >到期时间：{{item.endTime ? item.endTime.substring(0,10) : ""}}</p>
                                    <p
                                    v-if="item.setmealType==='2'"
                                    >到期时间：{{item.endTime ? item.endTime.substring(0,10) : ""}}</p>
                                    <p v-if="item.setmealType==='1'">剩余学时：{{item.availableTime}}</p> -->
                                    <p>最近学习：{{item.sectionName? item.sectionName : '未开始学习'}}</p>
                                    <p style="text-oveflow:clip"
                                    class="study-progress">学习进度：
                                    <el-progress
                                        :show-text="false"
                                        :stroke-width="14"
                                        :percentage="progress(item.studySection,item.countSection)"
                                        style="display:inline-block;top:3px;position:relative;"
                                    ></el-progress>
                                    <span class="pre-number">{{progress(item.studySection,item.countSection)}}%</span>
                                    </p>
                                </div>
                                <div style="clear:both;"></div>
                                <ul style="list-style:none" class="panel-icon">
                                    <li>
                                    <img
                                        src="../../../../assets/icon-panel01.png"
                                        @click="showStudyRecord(item.courseId,item.courseName,item.countSection,item.setmealCourseId, '学习')"
                                        style="cursor:pointer;"
                                    >
                                    <p>学习记录</p>
                                    </li>
                                    <li>
                                    <img
                                        src="../../../../assets/icon-panel02.png"
                                        @click="showStudyNote(item.courseId,item.setmealCourseId,item.courseName)"
                                        style="cursor:pointer;"
                                    >
                                    <p>学习笔记</p>
                                    </li>
                                    <li>
                                    <img
                                        src="../../../../assets/icon-panel03.png"
                                        style="cursor:pointer"
                                        @click="forget(item.courseId)"
                                    >
                                    <p>提点建议</p>
                                    </li>
                                    <div style="clear:both;"></div>
                                </ul>
                                </div>
                            </div>
                            <div class="panel-bottom">
                                <el-button
                                    v-if="trainClassDetail.statuName?trainClassDetail.statu === 2:true"
                                    type="primary"
                                    @click="checkCourseConstraint(item)"
                                >{{ start(item.sectionName) ? '继续学习' : '开始学习'}}</el-button>
                                <el-button type="primary" v-if="trainClassDetail.statuName?trainClassDetail.statu === 1 || trainClassDetail.statu === 3:false" disabled>{{ trainClassDetail.statuName || '已结束' }}</el-button>
                            </div>
                            </div>
                        </el-col>
                    </el-row>
                    <Nothing :show="companyClassInfo"></Nothing>

                </el-tab-pane>
                <el-tab-pane :label="'AETS考试指南（' + tabThreeList.length + '个）'" name="three" v-if="tabThreeList.length>0">
                    <el-row :gutter="20" style="margin-bottom: 40px;">
                        <el-col
                            :span="8"
                            v-for="item in tabThreeList"
                            :key="item.id"
                        >
                            <div class="class-panel button-width">
                            <div class="panel-top">
                                <div>
                                <div style="position: relative;">
                                    <img
                                    :src="showImage(item.courseId)"
                                    style="height:145px;width:100%;display:block;"
                                >
                                    <img
                                    src="@/assets/images/courseType3.png"
                                    class="courseTypeImg"
                                >
                                </div>
                                <div class="panel-top-right">
                                    <el-tooltip effect="dark" :content="item.courseName" placement="top-start">
                                    <h2>{{item.courseName}}</h2>
                                    </el-tooltip>
                                    <!-- <p
                                    v-if="item.setmealType==='3'"
                                    >到期时间：{{item.endTime ? item.endTime.substring(0,10) : ""}}</p>
                                    <p
                                    v-if="item.setmealType==='2'"
                                    >到期时间：{{item.endTime ? item.endTime.substring(0,10) : ""}}</p>
                                    <p v-if="item.setmealType==='1'">剩余学时：{{item.availableTime}}</p> -->
                                    <p>最近学习：{{item.sectionName? item.sectionName : '未开始学习'}}</p>
                                    <p style="text-oveflow:clip"
                                    class="study-progress">学习进度：
                                    <el-progress
                                        :show-text="false"
                                        :stroke-width="14"
                                        :percentage="progress(item.studySection,item.countSection)"
                                        style="display:inline-block;top:3px;position:relative;"
                                    ></el-progress>
                                    <span class="pre-number">{{progress(item.studySection,item.countSection)}}%</span>
                                    </p>
                                </div>
                                <div style="clear:both;"></div>
                                <ul style="list-style:none" class="panel-icon">
                                    <li>
                                    <img
                                        src="../../../../assets/icon-panel01.png"
                                        @click="showStudyRecord(item.courseId,item.courseName,item.countSection,item.setmealCourseId, '学习')"
                                        style="cursor:pointer;"
                                    >
                                    <p>学习记录</p>
                                    </li>
                                    <li>
                                    <img
                                        src="../../../../assets/icon-panel02.png"
                                        @click="showStudyNote(item.courseId,item.setmealCourseId,item.courseName)"
                                        style="cursor:pointer;"
                                    >
                                    <p>学习笔记</p>
                                    </li>
                                    <li>
                                    <img
                                        src="../../../../assets/icon-panel03.png"
                                        style="cursor:pointer"
                                        @click="forget(item.courseId)"
                                    >
                                    <p>提点建议</p>
                                    </li>
                                    <div style="clear:both;"></div>
                                </ul>
                                </div>
                            </div>
                            <div class="panel-bottom">
                                <el-button
                                    v-if="trainClassDetail.statuName?trainClassDetail.statu === 2:true"
                                    type="primary"
                                    @click="checkCourseConstraint(item)"
                                >{{ start(item.sectionName) ? '继续学习' : '开始学习'}}</el-button>
                                <el-button type="primary" v-if="trainClassDetail.statuName?trainClassDetail.statu === 1 || trainClassDetail.statu === 3:false" disabled>{{ trainClassDetail.statuName || '已结束' }}</el-button>
                            </div>
                            </div>
                        </el-col>
                    </el-row>
                    <Nothing :show="companyClassInfo"></Nothing>

                </el-tab-pane>
                <el-tab-pane :label="'AETS模拟测评（' + tabFourList.length + '个）'" name="four" v-if="tabFourList.length>0">
                    <el-row :gutter="20" style="margin-bottom: 40px;">
                      <el-col
                          :span="8"
                          v-for="item in tabFourList"
                          :key="item.id"
                      >
                          <div class="class-panel">
                          <div class="panel-top">
                              <div>
                              <div style="position: relative;">
                                  <img
                                  src="@/assets/images/moce_05.png"
                                  style="height:145px;width:100%;display:block;"
                              >
                                  <img
                                          src="@/assets/images/courseType4.png"
                                          class="courseTypeImg"
                                      >
                              </div>
                              <div class="panel-top-right">
                                  <el-tooltip effect="dark" :content="item.courseName" placement="top-start">
                                  <h2>{{item.courseName}}</h2>
                                  </el-tooltip>
                                  <!-- <p>最近考试时间：{{$store.state.lateScoreTime? $store.state.lateScoreTime.slice(0, -3) : '未进行考试'}}</p> -->
                                  <p>最近考试时间：{{item.lastLearnTime? item.lastLearnTime.slice(0, -3) : '未进行考试'}}</p>
                              </div>
                              <div style="clear:both;"></div>
                              <ul style="list-style:none" class="panel-icon">
                                  <li>
                                  <img
                                      src="../../../../assets/icon-panel01.png"
                                      @click="showStudyRecord(item.courseId,item.courseName,item.countSection,item.setmealCourseId, '考试')"
                                      style="cursor:pointer;"
                                  >
                                  <p>考试记录</p>
                                  </li>
                                  <li>
                                  <img
                                      src="../../../../assets/icon-panel03.png"
                                      style="cursor:pointer"
                                      @click="forget(item.courseId)">
                                  <p>提点建议</p>
                                  </li>
                                  <div style="clear:both;"></div>
                              </ul>
                              </div>
                          </div>
                          <div class="panel-bottom">
                              <el-button type="primary" @click="checkCourseConstraint(item,'first')">初试</el-button>
                              <el-button type="primary" @click="fushi(item)">复试</el-button>
                          </div>
                          </div>
                      </el-col>
                  </el-row>
                </el-tab-pane>


                <el-tab-pane :label="'军航专业课程（' + (tabFiveList.length+tabSixList.length) + '个）' " name="five" v-if="tabFiveList.length>0">
                    <el-row :gutter="20" style="margin-bottom: 40px;">
                        <el-col
                            :span="8"
                            v-for="item in tabFiveList.concat(tabSixList)"
                            :key="item.id"
                        >
                            <div class="class-panel button-width">
                            <div class="panel-top">
                                <div>
                                <div style="position: relative;">
                                    <img
                                    :src="showImage(item.courseId)"
                                    style="height:145px;width:100%;display:block;"
                                >
                                    <img
                                    src="@/assets/images/courseType5.png"
                                    class="courseTypeImg"
                                >
                                </div>
                                <div class="panel-top-right">
                                    <el-tooltip effect="dark" :content="item.courseName" placement="top-start">
                                    <h2>{{item.courseName}}</h2>
                                    </el-tooltip>
                                    <!-- <p
                                    v-if="item.setmealType==='3'"
                                    >到期时间：{{item.endTime ? item.endTime.substring(0,10) : ""}}</p>
                                    <p
                                    v-if="item.setmealType==='2'"
                                    >到期时间：{{item.endTime ? item.endTime.substring(0,10) : ""}}</p>
                                    <p v-if="item.setmealType==='1'">剩余学时：{{item.availableTime}}</p> -->
                                    <p>最近学习：{{item.sectionName? item.sectionName : '未开始学习'}}</p>
                                    <p style="text-oveflow:clip"
                                    class="study-progress">学习进度：
                                    <el-progress
                                        :show-text="false"
                                        :stroke-width="14"
                                        :percentage="progress(item.studySection,item.countSection)"
                                        style="display:inline-block;top:3px;position:relative;"
                                    ></el-progress>
                                    <span class="pre-number">{{progress(item.studySection,item.countSection)}}%</span>
                                    </p>
                                </div>
                                <div style="clear:both;"></div>
                                <ul style="list-style:none" class="panel-icon">
                                    <li>
                                    <img
                                        src="../../../../assets/icon-panel01.png"
                                        @click="showStudyRecord(item.courseId,item.courseName,item.countSection,item.setmealCourseId, '学习')"
                                        style="cursor:pointer;"
                                    >
                                    <p>学习记录</p>
                                    </li>
                                    <li>
                                    <img
                                        src="../../../../assets/icon-panel02.png"
                                        @click="showStudyNote(item.courseId,item.setmealCourseId,item.courseName)"
                                        style="cursor:pointer;"
                                    >
                                    <p>学习笔记</p>
                                    </li>
                                    <li>
                                    <img
                                        src="../../../../assets/icon-panel03.png"
                                        style="cursor:pointer"
                                        @click="forget(item.courseId)"
                                    >
                                    <p>提点建议</p>
                                    </li>
                                    <div style="clear:both;"></div>
                                </ul>
                                </div>
                            </div>
                            <!-- <div class="panel-bottom">
                                <el-button :disabled="item.courseId=='4F27DDFF91C84665815F7959E09500D3'"
                                    v-if="trainClassDetail.statuName?trainClassDetail.statu === 2:true"
                                    type="primary"
                                    @click="checkCourseConstraint(item)"
                                >{{ start(item.sectionName) ? '继续学习' : '开始学习'}}</el-button>
                                <el-button type="primary" v-if="trainClassDetail.statuName?trainClassDetail.statu === 1 || trainClassDetail.statu === 3:false" disabled>{{ trainClassDetail.statuName || '已结束' }}</el-button>
                            </div> -->
                            <div class="panel-bottom" v-if="item.courseId=='639175DCA1A04719805817CB8A9B9CB5'">
                                <el-button
                                    v-if="trainClassDetail.statuName?trainClassDetail.statu === 2:true"
                                    type="primary"
                                    @click="checkCourseConstraint(item)"
                                >{{ start(item.sectionName) ? '继续学习' : '开始学习'}}</el-button>
                                <el-button type="primary" v-if="trainClassDetail.statuName?trainClassDetail.statu === 1 || trainClassDetail.statu === 3:false" disabled>{{ trainClassDetail.statuName || '已结束' }}</el-button>
                            </div>
                            <div v-else class="panel-bottom">
                              <el-button :disabled="item.courseId=='4F27DDFF91C84665815F7959E09500D3'" type="primary" @click="checkCourseConstraint(item,'first')">开始考试</el-button>
                            </div>
                            </div>
                        </el-col>
                    </el-row>
                    <Nothing :show="companyClassInfo"></Nothing>
                </el-tab-pane>

                <!-- <el-tab-pane :label="'军航模拟测试（' + tabSixList.length + '个）'" name="six" v-if="tabSixList.length>0">
                    <el-row :gutter="20" style="margin-bottom: 40px;">
                      <el-col
                          :span="8"
                          v-for="item in tabSixList"
                          :key="item.id"
                      >
                          <div class="class-panel">
                          <div class="panel-top">
                              <div>
                              <div style="position: relative;">
                                  <img
                                  :src="showImage(item.courseId)"
                                  style="height:145px;width:100%;display:block;"
                              >
                                  <img
                                          src="@/assets/images/courseType6.png"
                                          class="courseTypeImg"
                                      >
                              </div>
                              <div class="panel-top-right">
                                  <el-tooltip effect="dark" :content="item.courseName" placement="top-start">
                                  <h2>{{item.courseName}}</h2>
                                  </el-tooltip>
                                  <p>最近考试时间：{{item.lastLearnTime? item.lastLearnTime.slice(0, -3) : '未进行考试'}}</p>
                              </div>
                              <div style="clear:both;"></div>
                              <ul style="list-style:none" class="panel-icon">
                                  <li>
                                  <img
                                      src="../../../../assets/icon-panel01.png"
                                      @click="showStudyRecord(item.courseId,item.courseName,item.countSection,item.setmealCourseId, '考试')"
                                      style="cursor:pointer;"
                                  >
                                  <p>考试记录</p>
                                  </li>
                                  <li>
                                  <img
                                      src="../../../../assets/icon-panel03.png"
                                      style="cursor:pointer"
                                      @click="forget(item.courseId)">
                                  <p>提点建议</p>
                                  </li>
                                  <div style="clear:both;"></div>
                              </ul>
                              </div>
                          </div>
                          <div class="panel-bottom">
                              <el-button type="primary" @click="checkCourseConstraint(item,'first')">开始考试</el-button>
                          </div>
                          </div>
                      </el-col>
                  </el-row>
                </el-tab-pane> -->
            </el-tabs>
            <Nothing :show="companyClassInfo"></Nothing>

        </div>
        <!-- <el-dialog title="提示" :visible.sync="tishiShow1" width="500px" height="310px">
          <div class="learning-system">
            <div style="font-size:16px;text-align:center;margin-bottom:60px;" class="div">
                正在启动学习客户端，请稍等
            </div>
          </div>
        </el-dialog> -->

    </div>
</template>
<script>
import LearningSystem from './learningSystem'
import config from '@/utils/config'
import {
  Loading
} from 'element-ui'
export default {
  components: {
    LearningSystem
  },
  data () {
    var checkTitle = (rule, value, callback) => {
      if (value.length > 50) {
        callback(new Error('标题不能超过50个字符'))
      } else if (value.length === 0) {
        callback(new Error('标题不能为空'))
      } else {
        callback()
      }
    }
    return {
      testform: {
        licenseType: ''
      },
      testformrules: {
        licenseType: [{ required: true, message: '请选择', trigger: 'blur' }]
      },
      LicenseCategoryOptions: [],
      tishiShow: false, // 点击模拟测试的复试时，弹出提示
      fushiData: {},
      ifTrainClass: false,
      trainClassId: '',
      timeLeft: [],
      mealTimeLeft: [],
      activeName: 'one',
      remain: 0,
      imageUrl: [],
      isForget: false,
      startStudy: false,
      canStudy: false,
      studyNote: false,
      studyRecord: false,
      showRecord: [],
      currentId: '',
      mealId: '',
      personCourseNull: false,
      companyCourseNull: false,
      noteInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      recordPage: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      suggestion_form: {
        label: '',
        needReply: false,
        title: '',
        content: '',
        imageUrl: []
      },
      suggestion_rules: {
        title: [{ validator: checkTitle, trigger: 'blur' }]
      },
      class_info: [],
      companyClassInfo: [],
      studyNoteList: [],
      checkAll: false,
      deleteList: [],
      recordList: [],
      subRecordList: [],
      studyNoteSection: {},
      section: '',
      studyTime: '',
      recordId: 0,
      currentCourseName: '',
      sectionId: '',
      currentCourseCount: 0,
      enterprise_id: 'csatmb',
      enterpriseUserId: sessionStorage.account,
      setmealCourseId: '',
      setmealId: '',
      // setmealType: "",
      mealType: '',
      enterprise_name: '',
      url: '',
      unfinishedList: [],
      courseList: [
        {
          id: 'AC96AEB02E384FCFB4767EBA2948ADD1',
          image: require('@/assets/images/hua1.png'),
          url: '../../../../assets/images/hua1.png',
          color: '#1b80df'
        },
        {
          id: '51B7563A144D43F6B9D6D006D6FBFBEF',
          image: require('@/assets/images/hua2.png'),
          url: '../../../../assets/images/hua2.png',
          color: '#7369ba'
        },
        {
          id: '2C6FD119D1E94D438D88B8DA28D11AF9',
          image: require('@/assets/images/hua3.png'),
          url: '../../../../assets/images/hua3.png',
          color: '#4fb04f'
        },
        {
          id: 'ED2F9C779DCD406C91AC76D4705BF3B1',
          image: require('@/assets/images/hua4.png'),
          url: '../../../../assets/images/hua4.png'
        },

        {
          id: '161289B039BA406BBFCC58D3A3053CE0',
          image: require('@/assets/images/hua5.png'),
          url: '@/assets/images/hua5.png'
        },
        {
          id: 'FB42A24373A444AD987D71C9A0EE8A8C',
          image: require('@/assets/images/hua6.png'),
          url: '@/assets/images/hua6.png'
        },
        {
          id: 'C719136A2692449FB659ACF3D0EA5EE0',
          image: require('@/assets/images/hua7.png'),
          url: '@/assets/images/hua7.png' // 5695
        },
        {
          id: '1C4E7F182A1E43DAAF06F45923ECC468',
          image: require('@/assets/images/hua8.png'),
          url: '@/assets/images/hua8.png'
        },
        {
          id: '0232B93BAAF142808364074F455DD609',
          image: require('@/assets/images/hua9.png'),
          url: '@/assets/images/hua9.png'
        },
        {
          id: 'CC82E18717BB4CDBB4FDF2C174A3509B',
          image: require('@/assets/images/hua10.png'),
          url: '@/assets/images/hua10.png'
        },
        {
          id: 'B9FF386CD5D84D5A811377CEC1CC1D51',
          image: require('@/assets/images/hua11.png'),
          url: '@/assets/images/hua11.png'
        },
        {
          id: '2EBF26A8F10F400D99FA37C63CA302D1',
          image: require('@/assets/images/hua12.png'),
          url: '@/assets/images/hua12.png'
        },
        {
          id: 'B6ACFE89F9A348E7B632F27766CCFD43',
          image: require('@/assets/images/hua13.png'),
          url: '@/assets/images/hua13.png'
        },
        {
          id: 'E8CFD0D1D1E44A97AD962A528F0CF6C6',
          image: require('@/assets/images/hua14.png'),
          url: '@/assets/images/hua14.png'
        },
        {
          id: 'E8CFD0D1D1E44A97AD962A528F0CF6C6',
          image: require('@/assets/images/hua14.png'),
          url: '@/assets/images/hua14.png'
        },
        {
          id: '4F27DDFF91C84665815F7959E09500D3',
          image: require('@/assets/images/hua15.png'),
          url: '@/assets/images/hua15.png'
        }
        ,
        {
          id: '639175DCA1A04719805817CB8A9B9CB5',
          image: require('@/assets/images/hua16.png'),
          url: '@/assets/images/hua16.png'
        }
      ],
      labelOptions: [],
      tabOneList: [],
      tabTwoList: [],
      tabThreeList: [],
      tabFourList: [],
      tabFiveList: [],
      tabSixList: [],
      page_size: 6,
      page_number: 1,
      total_count: 0,
      resultList: [],
      recordTitle: '', // 记录名称

      simulatedExamUrl: '', // 学习子系统路径
      isRoutineCourse: false, // 是否是常规课程页面
      pagerCount: 1
    }
  },
  computed: {

    trainClassDetail () {
      let data = JSON.parse(sessionStorage.getItem('trainClassDetail')) || {}
      let obj = {
        1: '未开始',
        2: '进行中',
        3: '已结束'
      }
      data.statuName = obj[data.statu]
      return data
    }
  },
  watch: {
    '$router' (to, form, next) {
      console.log(to, form)
    }
  },
  created () {
    let isRoutineCourse = this.$router.history.current.path == '/trainClass/personalCenter/learnCenter/mockTest' // 是否是常规课程页面
    this.isRoutineCourse = isRoutineCourse
    if (isRoutineCourse) {
      sessionStorage.setItem('trainClassDetail', JSON.stringify({}))
    }
    if (sessionStorage.token === '' || sessionStorage.token === undefined) {
      this.$message.info('请先登录')
      this.$router.push('/login')
    }
    this.getAllAdviceType()
  },
  mounted () {
    this.$ajax
      .post(
        '/studyapp-service/TbUserCourse/tbUserCourse',
        this.postData({
          id: sessionStorage.userUuid
        })
      )
      .then(res => {
        if (res.data.list.length > 0) {
          this.personCourseNull = false
          this.class_info = res.data.list
          let timeLeft = new Array()
          for (const i in this.class_info) {
            timeLeft.push(parseInt(this.class_info[i].remainingTime))
            var time = this.class_info[i].remainingTime
            this.class_info[i].remainingTime = this.caculateTime(time, 0)
          }
          this.timeLeft = timeLeft
        } else {
          this.personCourseNull = true
        }
      })
    this.trainClassId = this.$route.query.tsId
    this.getPage()
  },
  methods: {
    startStudyFunction(){
      //this.startStudy=true
      let loading = Loading.service({
        lock: true,
        text: 'Starting',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.2)'
      });
      setTimeout(()=>{
        loading.close()
      },20000)
      console.log(this.url.replace('https://192.168.1.239:5011','http://127.0.0.1:3000'));
      console.log(this.url.replaceAll('&','=='));
      try{
        this.$ajax
        .post('http://127.0.0.1:9789/runicao/run', this.postData({
          name:'在线学习平台-1.0.1003-arm64.AppImage',
          order:this.url.replaceAll('&','==')
        }))
        .then((res) => {
          
        })
      }catch(e){
        return true
      }
    },
    sizeChange (val) {
      this.page_size = val
      this.currentChange(1)
    },
    currentChange (val) {
      this.page_number = val
      // this.currentPageList()
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    // 获取标签数据字典
    getAllAdviceType () {
      this.$ajax
        .get(
          'studyapp-service/CourseAdvice/getAllAdviceType'
        )
        .then(res => {
          if (res.code == '200') {
            this.labelOptions = res.data
          }
        })
    },
    showImage (id) {
      for (let i = 0; i < this.courseList.length; i++) {
        if (id === this.courseList[i].id) {
          return this.courseList[i].image
        }
      }
    },
    getPage () {
      let OBJ = {}
      let URL = ''
      if (this.$route.name === 'mockTest') {
        this.ifTrainClass = false
        OBJ = { id: sessionStorage.userUuid }
        URL = '/enterprise-service/tbCourseUser/findForPage'
      } else {
        this.ifTrainClass = true
        OBJ = {
          id: sessionStorage.userUuid,
          tsId: this.$route.query.tsId
        }
        URL = '/enterprise-service/tbCourseUser/findForPageByTrainClass'
      }
      this.$ajax
        .post(URL, this.postData(OBJ))
        .then((res) => {
          if (res.data) {
            this.companyCourseNull = false
            this.companyClassInfo = JSON.parse(JSON.stringify(res.data))
            for (let i = 0; i < res.data.length; i++) {
              const item = res.data[i]
              let time = item.availableTime
              this.companyClassInfo[i].availableTime = this.caculateTime(time, 0)
            }
            if (res.data[0].courseId === '639175DCA1A04719805817CB8A9B9CB5') {
              this.activeName = 'five'
            } else if (res.data[0].courseId === '4F27DDFF91C84665815F7959E09500D3') {
              this.activeName = 'six'
            }else if (res.data[0].type === '1') {
              this.activeName = 'three'
            } else if (res.data[0].type === '2') {
              this.activeName = 'one'
            } else if (res.data[0].type === '3') {
              this.activeName = 'four'
            } else if (res.data[0].type === '4') {
              this.activeName = 'two'
            }
            this.tabThreeList = this.companyClassInfo.filter(item => item.type === '1') // AETS考试指南
            this.tabOneList = this.companyClassInfo.filter(item => (item.type === '2' && item.courseId!='639175DCA1A04719805817CB8A9B9CB5')) // 专业课程
            this.tabFourList = this.companyClassInfo.filter(item => item.type === '3' && item.courseId!='4F27DDFF91C84665815F7959E09500D3') // 模拟评测
            this.tabTwoList = this.companyClassInfo.filter(item => item.type === '4') // 专项练习
            this.tabFiveList = this.companyClassInfo.filter(item => item.courseId === '639175DCA1A04719805817CB8A9B9CB5') // 定制专业课程
            this.tabSixList = this.companyClassInfo.filter(item => item.courseId === '4F27DDFF91C84665815F7959E09500D3') // 定制评测
          } else {
            this.companyCourseNull = true
          }
        })
    },

    start (section) {
      if (section) {
        return true
      } else {
        return false
      }
    },

    progress (learned, total) {
      let result = 0
      if (total && total != 0) {
        result = (learned / total) * 100
        if (result > 100) {
          result = 100
        }
        return Number.parseInt(result)
      } else {
        return Number.parseInt(result)
      }
    },
    caculateTime1 (time, type) {
      if(time<1000){
        return '0秒'
      }
      var days = parseInt(time / (1000 * 60 * 60 * 24))
      var hours = parseInt((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + days * 24
      var minutes = parseInt((time % (1000 * 60 * 60)) / (1000 * 60))
      var seconds = (time % (1000 * 60)) / 1000
      let str = `${hours ? hours + '小时' : ''}  ${minutes ? minutes + '分钟' : ''}  ${seconds ? seconds.toFixed(0) + '秒' : ''}`
      return str
    },
    caculateTime (time, type) {
      var totalTime = ''
      if (time) {
        time = parseInt(time)
        let hours = (time / (1000 * 60 * 60)).toFixed(
          2
        )
        if (hours > 0) {
          hours = parseInt(hours)
        } else {
          hours = 0
        }
        let minutes = Math.round((time % (1000 * 60 * 60)) / (1000 * 60))

        if (hours === 0) {
          if (minutes <= 0) {
            if (type === 1) {
              totalTime = '不到1分钟'
            } else {
              totalTime = '学时已用完'
            }
          } else {
            totalTime = '' + parseInt(minutes) + '分钟'
          }
        } else {
          totalTime =
                        '' + parseInt(hours) + '小时' + parseInt(minutes) + '分钟'
        }

        return totalTime
      } else {
        if (type === 1) {
          totalTime = '不到1分钟'
        } else {
          totalTime = '学时已用完'
        }
        return totalTime
      }
    },
    caculateTime2 (time, type) {
      // var totalTime = ''
      // if (time) {
      //   time = parseInt(time)
      //   let hours = (time / (1000 * 60 * 60)).toFixed(
      //     2
      //   )
      //   if (hours > 0) {
      //     hours = parseInt(hours)
      //   } else {
      //     hours = 0
      //   }
      //   let minutes = Math.round((time % (1000 * 60 * 60)) / (1000 * 60))
      //   if (hours === 0) {
      //     if (minutes <= 0) {
      //       if (type === 1) {
      //         totalTime = '不到1分钟'
      //       } else {
      //         totalTime = '学时已用完'
      //         if (type === 2) {
      //           totalTime = '0分钟'
      //         }
      //       }
      //     } else {
      //       totalTime = '' + parseInt(minutes) + '分钟'
      //     }
      //   } else {
      //     totalTime =
      //                   '' + parseInt(hours) + '小时' + parseInt(minutes) + '分钟'
      //   }

      //   return totalTime
      // } else {
      //   if (type === 1) {
      //     totalTime = '不到1分钟'
      //   } else {
      //     totalTime = '学时已用完'
      //   }
      //   return totalTime
      // }

      if(!time){
          return ''
      }
      let _time=parseInt(time.toString());  //毫秒数
      if(_time<=0){
          return ''
      }
      if(_time<60000){
          if(_time<1000){
              _time=1000;
          }
          return `${Math.ceil(_time/1000)}秒`
      }else{
          time = parseInt(time.toString())/1000;
          let h = Math.floor(time/(60*60));
          let m = Math.floor((time%(3600))/60);
          let s = Math.ceil(time%(60));
          let str = '';
          if(h>0) str += h + '小时';
          if(m>0) str += m + '分钟';
          if(s>0){
              str += s + '秒';
          }
          return str;
      }
    },
    handleClosetishi () {
      this.tishiShow = false
      this.$refs.testform.clearValidate()
      this.$refs.testform.resetFields()
    },
    async fushi (item) {
      let {data} = await this.TrainClassTestApi.findDictsByUuid({uuid: '454DGGD4200956JVDKJ3983JVDJ3993' })
      this.LicenseCategoryOptions = data.map(el => el.dictValue)
      this.tishiShow = true
      this.fushiData = item
    },
    submitLicenseCategory () {
      this.$refs.testform.validate((valid) => {
        if (valid) {
          this.tishiShow = false
          this.checkCourseConstraint(this.fushiData, 'second')
        } else {
          return false
        }
      })
    },
    // 校验课程约束
    checkCourseConstraint (item, type) {
      
      let data = {courseId: item.courseId, key: 'courseConstraint'}
      if (this.trainClassId) {
        data.trainClassId = this.trainClassId// 培训班 classId
      }
      this.$ajax
        .post(
          '/auth-config-service/dict/checkCourseConstraint',
          this.postData(data)
        )
        .then((res) => {
          if (!res.data.status || res.code != 200) {
            this.$message({
              message: res.data.msg || res.message,
              type: 'warning'
            })
          } else {
            this.mealStartStudy(item, type)
          }
        })
    },
    mealStartStudy (item, type) {
      this.$ajax
        .post(
          '/auth-config-service/sysDict/findDictByParam',
          this.postData({
            pageNumber: 1,
            pageSize: 99,
            dictKey: 'simulatedExamUrl'
          })
        )
        .then((res) => {
          if (res.code != '1') {
            this.$message({
              message: res.data.msg || res.message,
              type: 'warning'
            })
          } else {
            
            if (item.courseId == 'ED2F9C779DCD406C91AC76D4705BF3B1' || item.courseId == '4F27DDFF91C84665815F7959E09500D3' || item.courseId == 'C719136A2692449FB659ACF3D0EA5EE0' || item.courseId == 'AC96AEB02E384FCFB4767EBA2948ADD1') {
              this.simulatedExamUrl = res.data.list[0].dictValue
            } else {
              this.simulatedExamUrl = config.studyPath
            }
            
            if (this.trainClassId) {
              this.mealStartStudy_2(item, type) // 培训班 classId
            } else {
              this.mealStartStudy_1(item, type)
            }
          }
        })
    },

    async mealStartStudy_1 (item, type) {
      let ids=['ED2F9C779DCD406C91AC76D4705BF3B1','4F27DDFF91C84665815F7959E09500D3']
      if ( ids.includes(item.courseId)) { // 考试模式
        this.$ajax.post(
          'studyapp-service/TbStudyLog/getUserStudyInfo',
          this.postData({
            data: JSON.stringify([
              {
                id: '2C6FD119D1E94D438D88B8DA28D11AF9',
                courceName: '管制员英语陆空通话课程CBT软件'
              }, {
                id: '51B7563A144D43F6B9D6D006D6FBFBEF',
                courceName: '管制员ICAO特情英语课程CBT软件'
              }, {
                id: 'AC96AEB02E384FCFB4767EBA2948ADD1',
                courceName: '管制员英语测试考试指南学习软件'
              },
              {
                id:'B6ACFE89F9A348E7B632F27766CCFD43',
                courceName: '陆空通话训练CBT软件'
              },
              {
                id:'FB42A24373A444AD987D71C9A0EE8A8C',
                courceName: '非常规陆空通话英语CBT软件'
              },
              {
                id:'2EBF26A8F10F400D99FA37C63CA302D1',
                courceName: '基础英语学习CBT软件'
              },
              {
                id:'1C4E7F182A1E43DAAF06F45923ECC468',
                courceName: '管制英语阅读CBT软件'
              },
              {
                id:'161289B039BA406BBFCC58D3A3053CE0',
                courceName: 'Aviation English for ICAO Compliance CBT'
              },
              {
                id:'0232B93BAAF142808364074F455DD609',
                courceName: '管制特情英语专题训练CBT软件'
              },
              {
                id:'E8CFD0D1D1E44A97AD962A528F0CF6C6',
                courceName: '听说训练CBT软件'
              },
              {
                id:'CC82E18717BB4CDBB4FDF2C174A3509B',
                courceName: '管制特情英语云课堂微课'
              },
              {
                id:'639175DCA1A04719805817CB8A9B9CB5',
                courceName: 'JH学习'
              },
            ]),
            testId: item.courseId
          })
        ).then(res => {
          let data = res.data.list.map(e=>{
            return {
              id: e.courseId,
              chapterStudyTime: e.chapterStudyTime ? e.chapterStudyTime : 0,
              courseName: e.courseName
            }
          })
          this.unfinishedList = []

        //   for (var i = 0; i < res.data.list.length; i++) {
        //     data.push({
        //       id: res.data.list[i].courseId,
        //       chapterStudyTime: res.data.list[i].chapterStudyTime ? res.data.list[i].chapterStudyTime : 0,
        //       courseName: res.data.list[i].courseName
        //     })
        //   }
          this.$ajax.post(
            'auth-config-service/dict/checkStudyTime',
            this.postData({
              data: JSON.stringify(data),
              endTestCount: res.data.endTestCount,
              testCount: res.data.testCount ? res.data.testCount : 0
            })
          ).then(res => {
            // if (!res.data.canTest && item.courseId!='4F27DDFF91C84665815F7959E09500D3') {
            if (!res.data.canTest) {
              this.canStudy = true
              this.unfinishedList = []
              // for (let i = 0; i < res.data.nameList.length; i++) {
              //   this.unfinishedList.push({
              //     name: res.data.nameList[i],
              //     time: res.data.timeList[i]
              //   })
              // }
              
              for (let i = 0; i < res.data.courses.length; i++) {
                this.unfinishedList.push({
                  name: res.data.courses[i].courseId,
                  time: res.data.courses[i].duration
                })
              }
              return false
            } else {
              this.$ajax
                .post(
                  'studyapp-service/courseApp/getContinueToLearn',
                  this.postData({
                    courseId: item.courseId,
                    seatMealCourseId: item.setmealCourseId
                  })
                )
                .then(res => {
                  if (res.code === '200') {
                    this.sectionId = res.data.sectionId
                    // this.enterpriseUserId = item.enterpriseUserId
                    this.setmealCourseId = item.setmealCourseId
                    // this.setmealType = item.setmealType
                    // this.enterprise_id = item.enterprise_id
                    this.enterprise_name = item.enterprise_name
                    this.setmealId = item.setmealId
                    // this.url = `learningSystem:host=${config.baseUrl}&studyPath=${config.studyPath
                    //     }&type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
                    //     }&setmealCourseId=${this.setmealCourseId}
                    //     &headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
                    //     }&setmealId=${this.setmealId}&token=${sessionStorage.token
                    //     }&continueLearning=${this.sectionId}&isJudgment=${item.isJudgment
                    //     }&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}`
// linux环境
//                      this.url = `${this.simulatedExamUrl
//                      }?host=${config.baseUrl}&type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
//  }&setmealCourseId=${this.setmealCourseId}&headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
//  }&setmealId=${this.setmealId}&token=${sessionStorage.token
//  }&continueLearning=${this.sectionId}&isJudgment=${item.isJudgment
//  }&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}&userId=${sessionStorage.userUuid}&licenseType=${this.testform.licenseType}`
//                      this.startStudyFunction()
// linux环境
                   this.url = `${this.simulatedExamUrl
                                       }?host=${config.baseUrl}&type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
                   }&setmealCourseId=${this.setmealCourseId}&headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
                   }&setmealId=${this.setmealId}&token=${sessionStorage.token
                   }&continueLearning=${this.sectionId}&isJudgment=${item.isJudgment
                   }&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}&userId=${sessionStorage.userUuid}&licenseType=${this.testform.licenseType}`
                   this.startStudy = true
                  } else {
                    // 456654
                    // this.enterpriseUserId = item.enterpriseUserId
                    this.setmealCourseId = item.setmealCourseId
                    // this.setmealType = item.setmealType
                    // this.enterprise_id = item.enterprise_id
                    this.enterprise_name = item.enterprise_name
                    this.setmealId = item.setmealId
                    // this.url = `learningSystem:host=${config.baseUrl}&studyPath=${config.studyPath
                    //     }&type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
                    //     }&setmealCourseId=${this.setmealCourseId}
                    //     &headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
                    //     }&setmealId=${this.setmealId}&token=${sessionStorage.token
                    //     }&continueLearning=${""}&isJudgment=${item.isJudgment}&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}`
                    // linux环境
//                      this.url = `${this.simulatedExamUrl
//                      }?host=${config.baseUrl}&type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
//                      }&setmealCourseId=${this.setmealCourseId}&headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
//  }&setmealId=${this.setmealId}&token=${sessionStorage.token
//  }&continueLearning=${''}&isJudgment=${item.isJudgment}&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}&userId=${sessionStorage.userUuid}&licenseType=${this.testform.licenseType}`
//                      this.startStudyFunction()
                    // linux环境
                   this.url = `${this.simulatedExamUrl
                   }?host=${config.baseUrl}&type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
                   }&setmealCourseId=${this.setmealCourseId}&headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
}&setmealId=${this.setmealId}&token=${sessionStorage.token
}&continueLearning=${''}&isJudgment=${item.isJudgment}&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}&userId=${sessionStorage.userUuid}&licenseType=${this.testform.licenseType}`
                   this.startStudy = true
                  }
                  console.log(this.url,'this.url')
                })
            }
          })
        })
      } else {
        this.$ajax
          .post(
            'studyapp-service/courseApp/getContinueToLearn',
            this.postData({
              courseId: item.courseId,
              seatMealCourseId: item.setmealCourseId
            })
          )
          .then(res => {
            if (res.code === '200') {
              this.sectionId = res.data.sectionId
              // this.enterpriseUserId = item.enterpriseUserId
              this.setmealCourseId = item.setmealCourseId
              // this.setmealType = item.setmealType
              // this.enterprise_id = item.enterprise_id
              this.enterprise_name = item.enterprise_name
              this.setmealId = item.setmealId
              // this.url = `host=${config.baseUrl}&studyPath=${config.studyPath
              //     }&type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
              //     }&setmealCourseId=${this.setmealCourseId}
              //     &headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
              //     }&setmealId=${this.setmealId}&token=${sessionStorage.token
              //     }&continueLearning=${this.sectionId}&isJudgment=${item.isJudgment
              //     }&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}`
              // linux环境
//                this.url = `${this.simulatedExamUrl
//                }?host=${config.baseUrl}&type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
//                }&setmealCourseId=${this.setmealCourseId}&headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
//  }&setmealId=${this.setmealId}&token=${sessionStorage.token
//  }&continueLearning=${this.sectionId}&isJudgment=${item.isJudgment
//  }&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}&userId=${sessionStorage.userUuid}`
//                //  this.url = `${config.studyPath}?id=${item.courseId}`
//                this.startStudyFunction()
              // linux环境
             this.url = `${this.simulatedExamUrl
             }?host=${config.baseUrl}&type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
             }&setmealCourseId=${this.setmealCourseId}&headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
}&setmealId=${this.setmealId}&token=${sessionStorage.token
}&continueLearning=${this.sectionId}&isJudgment=${item.isJudgment
}&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}&userId=${sessionStorage.userUuid}`
             this.startStudy = true
            } else {
              // this.enterpriseUserId = item.enterpriseUserId
              this.setmealCourseId = item.setmealCourseId
              // this.setmealType = item.setmealType
              // this.enterprise_id = item.enterprise_id
              this.enterprise_name = item.enterprise_name
              this.setmealId = item.setmealId
              // this.url = `host=${config.baseUrl}&studyPath=${config.studyPath
              //     }&type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
              //     }&setmealCourseId=${this.setmealCourseId}
              //     &headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
              //     }&setmealId=${this.setmealId}&token=${sessionStorage.token
              //     }&continueLearning=${""}&isJudgment=${item.isJudgment
              //     }&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}`
              console.log(this.simulatedExamUrl);
              // linux环境
//                this.url = `${this.simulatedExamUrl
//                }?host=${config.baseUrl}&type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
//                }&setmealCourseId=${this.setmealCourseId}&headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
//  }&setmealId=${this.setmealId}&token=${sessionStorage.token
//  }&continueLearning=${''}&isJudgment=${item.isJudgment
//  }&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}&userId=${sessionStorage.userUuid}`
//                this.startStudyFunction()
              // linux环境
              this.url = `${this.simulatedExamUrl
              }?host=${config.baseUrl}&type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
              }&setmealCourseId=${this.setmealCourseId}&headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
}&setmealId=${this.setmealId}&token=${sessionStorage.token
}&continueLearning=${''}&isJudgment=${item.isJudgment
}&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}&userId=${sessionStorage.userUuid}`
              this.startStudy = true
            }
          })
      }
      // if(item.)
    },
    async mealStartStudy_2 (item, type) {
      
      let trainClassId = this.trainClassId
      let ids=['ED2F9C779DCD406C91AC76D4705BF3B1','4F27DDFF91C84665815F7959E09500D3']
      if (ids.includes(item.courseId)) {
        this.$ajax.post(
          'studyapp-service/trainClassTest/getUserStudyInfo',
          this.postData({
            data: JSON.stringify([
              {
                id: '2C6FD119D1E94D438D88B8DA28D11AF9',
                courceName: '管制员英语陆空通话课程CBT软件'
              }, {
                id: '51B7563A144D43F6B9D6D006D6FBFBEF',
                courceName: '管制员ICAO特情英语课程CBT软件'
              }, {
                id: 'AC96AEB02E384FCFB4767EBA2948ADD1',
                courceName: '管制员英语测试考试指南学习软件'
              },
              {
                id:'B6ACFE89F9A348E7B632F27766CCFD43',
                courceName: '陆空通话训练CBT软件'
              },
              {
                id:'FB42A24373A444AD987D71C9A0EE8A8C',
                courceName: '非常规陆空通话英语CBT软件'
              },
              {
                id:'2EBF26A8F10F400D99FA37C63CA302D1',
                courceName: '基础英语学习CBT软件'
              },
              {
                id:'1C4E7F182A1E43DAAF06F45923ECC468',
                courceName: '管制英语阅读CBT软件'
              },
              {
                id:'161289B039BA406BBFCC58D3A3053CE0',
                courceName: 'Aviation English for ICAO Compliance CBT'
              },
              {
                id:'0232B93BAAF142808364074F455DD609',
                courceName: '管制特情英语专题训练CBT软件'
              },
              {
                id:'E8CFD0D1D1E44A97AD962A528F0CF6C6',
                courceName: '听说训练CBT软件'
              },
              {
                id:'CC82E18717BB4CDBB4FDF2C174A3509B',
                courceName: '管制特情英语云课堂微课'
              },
              {
                id:'639175DCA1A04719805817CB8A9B9CB5',
                courceName: 'JH学习'
              },
            ]),
            testId: item.courseId,
            trainClassId
          })
        ).then(res => {
          let data = []
          for (var i = 0; i < res.data.list.length; i++) {
            data.push({
              id: res.data.list[i].courseId,
              chapterStudyTime: res.data.list[i].chapterStudyTime ? res.data.list[i].chapterStudyTime : 0,
              courseName: res.data.list[i].courseName
            })
          }
          this.$ajax.post(
            'auth-config-service/dict/checkClassStudyTime',
            this.postData({
              data: JSON.stringify(data),
              endTestCount: res.data.endTestCount,
              testCount: res.data.testCount ? res.data.testCount : 0,
              trainClassId
            })
          ).then(res => {
            // if (!res.data.canTest && item.courseId!='4F27DDFF91C84665815F7959E09500D3') {
            if (!res.data.canTest) {
                this.unfinishedList = []
                this.canStudy = true
              // for (let i = 0; i < res.data.nameList.length; i++) {
              //   this.unfinishedList.push({
              //     name: res.data.nameList[i],
              //     time: res.data.timeList[i]
              //   })
              // }
              
              for (let i = 0; i < res.data.courses.length; i++) {
                this.unfinishedList.push({
                  name: res.data.courses[i].courseId,
                  time: res.data.courses[i].duration
                })
              }
              return false
            } else {
              this.$ajax
                .get(
                  `studyapp-service/courseApp/getContinueToLearn2?courseId=${item.courseId}&seatMealCourseId=${item.setmealCourseId}&tsId=${this.trainClassId ? this.trainClassId : ''}`
                  // this.postData({
                  //     courseId: item.courseId,
                  //     seatMealCourseId: item.setmealCourseId,
                  //     // trainClassId
                  // })
                )
                .then(res => {
                  if (res.code === '200') {
                    this.sectionId = res.data.sectionId
                    // this.enterpriseUserId = item.enterpriseUserId
                    this.setmealCourseId = item.setmealCourseId
                    // this.setmealType = item.setmealType
                    // this.enterprise_id = item.enterprise_id
                    this.enterprise_name = item.enterprise_name
                    this.setmealId = item.setmealId
                    // this.url = `learningSystem:host=${config.baseUrl}&studyPath=${config.studyPath
                    //     }&type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
                    //     }&setmealCourseId=${this.setmealCourseId}&trainClassId=${this.trainClassId}
                    //     &headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
                    //     }&setmealId=${this.setmealId}&token=${sessionStorage.token
                    //     }&continueLearning=${this.sectionId}&isJudgment=${item.isJudgment
                    //     }&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}`
                    // linux环境
//                    this.url = `${this.simulatedExamUrl
//                    }?host=${config.baseUrl}&type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
//}&setmealCourseId=${this.setmealCourseId}&trainClassId=${this.trainClassId}&headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
//}&setmealId=${this.setmealId}&token=${sessionStorage.token
//}&continueLearning=${this.sectionId}&isJudgment=${item.isJudgment
//}&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}&userId=${sessionStorage.userUuid}&licenseType=${this.testform.licenseType}`

//                    this.startStudyFunction()
                    // linux环境
                    this.url = `${this.simulatedExamUrl
                    }?host=${config.baseUrl}
                                            &type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
}&setmealCourseId=${this.setmealCourseId}&trainClassId=${this.trainClassId}&headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
}&setmealId=${this.setmealId}&token=${sessionStorage.token
}&continueLearning=${this.sectionId}&isJudgment=${item.isJudgment
}&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}&userId=${sessionStorage.userUuid}&licenseType=${this.testform.licenseType}`

                    this.startStudy = true
                  } else {
                    // this.enterpriseUserId = item.enterpriseUserId
                    this.setmealCourseId = item.setmealCourseId
                    // this.setmealType = item.setmealType
                    // this.enterprise_id = item.enterprise_id
                    this.enterprise_name = item.enterprise_name
                    this.setmealId = item.setmealId
                    // this.url = `learningSystem:host=${config.baseUrl}&studyPath=${config.studyPath
                    //     }&type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
                    //     }&setmealCourseId=${this.setmealCourseId}&trainClassId=${this.trainClassId}
                    //     &headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
                    //     }&setmealId=${this.setmealId}&token=${sessionStorage.token
                    //     }&continueLearning=${""}&isJudgment=${item.isJudgment
                    //     }&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}`
// linux环境
//                    this.url = `${this.simulatedExamUrl
//                    }?host=${config.baseUrl}&type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
//}&setmealCourseId=${this.setmealCourseId}&trainClassId=${this.trainClassId}&headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
//}&setmealId=${this.setmealId}&token=${sessionStorage.token
//}&continueLearning=${''}&isJudgment=${item.isJudgment
//}&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}&userId=${sessionStorage.userUuid}&licenseType=${this.testform.licenseType}`

//                    this.startStudyFunction()
// linux环境
                    this.url = `${this.simulatedExamUrl
                    }?host=${config.baseUrl}
                                            &type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
}&setmealCourseId=${this.setmealCourseId}&trainClassId=${this.trainClassId}&headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
}&setmealId=${this.setmealId}&token=${sessionStorage.token
}&continueLearning=${''}&isJudgment=${item.isJudgment
}&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}&userId=${sessionStorage.userUuid}&licenseType=${this.testform.licenseType}`

                    this.startStudy = true
                  }
                })
            }
          })
        })
      } else {
        this.$ajax
          .post(
            `studyapp-service/courseApp/getContinueToLearn2?courseId=${item.courseId}&seatMealCourseId=${item.setmealCourseId}&tsId=${this.trainClassId ? this.trainClassId : ''}`
            // this.postData({
            //     courseId: item.courseId,
            //     seatMealCourseId: item.setmealCourseId,
            //     // trainClassId
            // })
          )
          .then(res => {
            if (res.code === '200') {
              this.sectionId = res.data.sectionId
              // this.enterpriseUserId = item.enterpriseUserId
              this.setmealCourseId = item.setmealCourseId
              // this.setmealType = item.setmealType
              // this.enterprise_id = item.enterprise_id
              this.enterprise_name = item.enterprise_name
              this.setmealId = item.setmealId
              // this.url = `learningSystem:host=${config.baseUrl}&studyPath=${config.studyPath
              //     }&type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
              //     }&setmealCourseId=${this.setmealCourseId}&trainClassId=${this.trainClassId}
              //     &headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
              //     }&setmealId=${this.setmealId}&token=${sessionStorage.token
              //     }&continueLearning=${this.sectionId}&isJudgment=${item.isJudgment
              //     }&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}`
// linux环境
//              this.url = `${this.simulatedExamUrl
//              }?host=${config.baseUrl}&type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
//}&setmealCourseId=${this.setmealCourseId}&trainClassId=${this.trainClassId}&headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
//}&setmealId=${this.setmealId}&token=${sessionStorage.token
//}&continueLearning=${this.sectionId}&isJudgment=${item.isJudgment
//}&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}&userId=${sessionStorage.userUuid}`

//              this.startStudyFunction()
// linux环境
              this.url = `${this.simulatedExamUrl
              }?host=${config.baseUrl}
                                &type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
}&setmealCourseId=${this.setmealCourseId}&trainClassId=${this.trainClassId}&headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
}&setmealId=${this.setmealId}&token=${sessionStorage.token
}&continueLearning=${this.sectionId}&isJudgment=${item.isJudgment
}&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}&userId=${sessionStorage.userUuid}`

              this.startStudy = true
            } else {
              // this.enterpriseUserId = item.enterpriseUserId
              this.setmealCourseId = item.setmealCourseId
              // this.setmealType = item.setmealType
              // this.enterprise_id = item.enterprise_id
              this.enterprise_name = item.enterprise_name
              this.setmealId = item.setmealId
              // this.url = `learningSystem:host=${config.baseUrl}&studyPath=${config.studyPath
              //     }&type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
              //     }&setmealCourseId=${this.setmealCourseId}&trainClassId=${this.trainClassId}
              //     &headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
              //     }&setmealId=${this.setmealId}&token=${sessionStorage.token
              //     }&continueLearning=${""}&isJudgment=${item.isJudgment
              //     }&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}`
// linux环境
//              this.url = `${this.simulatedExamUrl
//              }?host=${config.baseUrl}&type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
//}&setmealCourseId=${this.setmealCourseId}&trainClassId=${this.trainClassId}&headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
//}&setmealId=${this.setmealId}&token=${sessionStorage.token
//}&continueLearning=${''}&isJudgment=${item.isJudgment
//}&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}&userId=${sessionStorage.userUuid}`

//              this.startStudyFunction()
// linux环境
              this.url = `${this.simulatedExamUrl
                            }?host=${config.baseUrl}
                                              &type=3&id=${item.courseId}&enterpriseUserId=${this.enterpriseUserId
              }&setmealCourseId=${this.setmealCourseId}&trainClassId=${this.trainClassId}&headUrl=${sessionStorage.headUrl}&enterprise_id=${this.enterprise_id}&enterprise_name=${this.enterprise_name
              }&setmealId=${this.setmealId}&token=${sessionStorage.token
             }&continueLearning=${''}&isJudgment=${item.isJudgment
              }&name=${sessionStorage.userName}&filePath=${config.resourceUrl}&ExamType=${type}&userId=${sessionStorage.userUuid}`

              this.startStudy = true
            }
          })
      }
    },

    handleImgSuccess (res, file) {
      this.imageUrl.push(URL.createObjectURL(file.raw))
      this.suggestion_form.imageUrl.push(res.data)
    },
    beforeImgUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG && !isPNG) {
        this.$message.error('上传图片只能是 JPG或PNG 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return false
      }
      return true
    },
    closeDialog () {
      this.$refs['suggestion_form'].clearValidate()
      this.suggestion_form.label = ''
      this.suggestion_form.content = ''
      this.suggestion_form.title = ''
      this.imageUrl = []
    },
    closeStudyNote () {
      this.showRecord = []
    },
    forget (courseId) {
      this.isForget = true
      this.currentId = courseId
    },
    descInput () {
      var txtVal = this.suggestion_form.content.length
      this.remain = txtVal
    },
    submitSuggestion () {
      this.$refs['suggestion_form'].validate(valid => {
        if (valid) {
          var needReply
          if (this.suggestion_form.needReply) {
            needReply = 1
          } else {
            needReply = 0
          }
          let filePath = ''
          if (this.suggestion_form.imageUrl.length > 0) {
            filePath = this.suggestion_form.imageUrl.join(',')
          }
          console.log(filePath, 111)
          this.$ajax
            .post(
              '/studyapp-service/CourseAdvice/addCourseAdvice',
              this.postData({
                trainClassId: this.$route.query.tsId,
                courseId: this.currentId,
                userId: sessionStorage.userUuid,
                type: this.suggestion_form.label,
                title: this.suggestion_form.title,
                content: this.suggestion_form.content,
                filePath: filePath,
                isReply: needReply
              })
            )
            .then(res => {
              if (res.code == 200) {
                this.isForget = false
                this.suggestion_form.imageUrl = []
                this.closeDialog()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      })
    },
    currentChangeCtudyNote (val) {
      this.noteInfo.pageNum = val
      this.setstudyNoteList()
    },
    setstudyNoteList () {
      let param = {
        trainClassId: this.$route.query.tsId,
        courseId: this.currentId,
        createUserId: sessionStorage.userUuid,
        seatMealCourseId: this.mealId,
        pageNumber: this.noteInfo.pageNum,
        pageSize: this.noteInfo.pageSize
      }
      if (this.seatMealCourseId) {
        param.seatMealCourseId = this.seatMealCourseId
      } else {
        param.seatMealCourseId = 'abc'
      }
      this.$ajax
        .post(
          '/studyapp-service/CourseNote/courseNoteByparam',
          this.postData(param)
        )
        .then(res => {
          console.log(res.data)
          this.noteInfo.pageNum = res.data.pageNumber
          this.noteInfo.pageSize = res.data.pageSize
          this.noteInfo.total = res.data.totalCount
          // this.studyNoteList = res.data.list;
          let nodeId = []
          let nodeIdStr = ''
          for (let i in res.data.list) {
            nodeId[i] = res.data.list[i].nodeId
          }
          nodeIdStr = nodeId.join(',')
          this.$ajax
            .post(
              'bus-pro-service/course/getNodeId',
              this.postData({
                nodeId: nodeIdStr
              })
            )
            .then(ress => {
              // let c = "259D3B825CFE4B65863AF5CEAB62B9B7";
              // alert(res.data.c);
              // this.studyNoteSection = res.data;
              for (let i = 0; i < res.data.list.length; i++) {
                const item = res.data.list[i]
                item.aaa = ress.data[item.nodeId]
              }
              this.studyNoteList = res.data.list
              console.log(this.studyNoteList, 'studyNoteList')
            })
        })
    },
    showStudyNote (courseID, mealId, courseName) {
      this.currentCourseName = courseName
      this.currentId = courseID
      this.mealId = mealId
      this.currentChangeCtudyNote(1)

      this.studyNote = true
    },
    showStudyRecord (courseID, courseName, courseCount, mealId, title) {
      this.currentId = courseID
      this.currentCourseName = courseName
      this.currentCourseCount = courseCount
      this.recordTitle = title

      if (mealId) {
        this.$ajax
          .post(
            '/studyapp-service/TbStudyLog/tbStudyLogByparam',
            this.postData({
              trainClassId: this.$route.query.tsId,
              courseId: courseID,
              userId: sessionStorage.userUuid,
              seatMealCourseId: mealId,
              pageNumber: this.recordPage.pageNum,
              pageSize: this.recordPage.pageSize
            })
          )
          .then(res => {
            this.recordPage.pageNum = res.data.pageNumber
            this.recordPage.pageSize = res.data.pageSize
            this.recordPage.total = res.data.totalCount
            this.recordList = res.data.list
            this.studyRecord = true
            document.documentElement.style.overflow = 'hidden'
            document.body.scrollTop = document.documentElement.scrollTop = 0
          })
      } else {
        this.$ajax
          .post(
            '/studyapp-service/TbStudyLog/tbStudyLogByparam',
            this.postData({
              trainClassId: this.$route.query.tsId,
              courseId: courseID,
              userId: sessionStorage.userUuid,
              seatMealCourseId: 'abc',
              pageNumber: this.recordPage.pageNum,
              pageSize: this.recordPage.pageSize
            })
          )
          .then(res => {
            this.recordPage.pageNum = res.data.pageNumber
            this.recordPage.pageSize = res.data.pageSize
            this.recordPage.total = res.data.totalCount
            this.recordList = res.data.list
            this.studyRecord = true
            document.documentElement.style.overflow = 'hidden'
            document.body.scrollTop = document.documentElement.scrollTop = 0
          })
      }
    },
    handleCurrentChange () {
      this.$ajax
        .post(
          '/studyapp-service/CourseNote/courseNoteByparam',
          this.postData({
            trainClassId: this.$route.query.tsId,
            courseId: this.currentId,
            createUserId: sessionStorage.userUuid,
            pageNumber: this.noteInfo.pageNum
          })
        )
        .then(res => {
          this.noteInfo.pageNum = res.data.pageNumber
          this.noteInfo.pageSize = res.data.pageSize
          this.noteInfo.total = res.data.totalCount
          this.studyNoteList = res.data.list
          console.log(this.studyNoteList, 'studyNoteList')
        })
    },
    handleRecordSizeChange (val) {
      this.recordPage.pageSize = val
      this.handleRecordChange(1)
    },
    handleRecordChange (val) {
      this.recordPage.pageNum = val
      this.$ajax
        .post(
          '/studyapp-service/TbStudyLog/tbStudyLogByparam',
          this.postData({
            trainClassId: this.$route.query.tsId,
            courseId: this.currentId,
            userId: sessionStorage.userUuid,
            pageNumber: this.recordPage.pageNum,
            pageSize: this.recordPage.pageSize
          })
        )
        .then(res => {
          this.recordPage.pageNum = res.data.pageNumber
          this.recordPage.pageSize = res.data.pageSize
          this.recordPage.total = res.data.totalCount
          this.recordList = res.data.list
        })
    },
    handleCheckAllChange (val) {
      var allList = []
      for (var i in this.studyNoteList) {
        allList[i] = this.studyNoteList[i].id
      }
      this.deleteList = val ? allList : []
    },
    deleteStudyNote () {
      if (this.deleteList && this.deleteList.length == 0) {
        this.$message.error('请勾选学习笔记！')
        return
      }
      var list = JSON.stringify(this.deleteList)
      console.log(this.deleteList, 'this.deleteList')

      this.studyNoteList = this.studyNoteList.filter(el => !this.deleteList.some(item => item === el.id))
      console.log(this.studyNoteList, 'this.studyNoteList')

      this.$ajax
        .post(
          '/studyapp-service/CourseNote/deleteCourseNote',
          this.postData({
            id: list
          })
        )
        .then(res => {
          if (res.code == 200) {
            this.$message({
              message: '操作成功！',
              type: 'success'
            })
            this.currentChangeCtudyNote(1)
          }
        })
    },
    changeRecord (index, courseId, createTime, mealId) {
      if (!this.showRecord[index]) {
        this.showRecord[index] = this.$set(this.showRecord, index, true)
        this.$ajax
          .post(
            '/studyapp-service/TbUserCourse/getStudyLogList',
            this.postData({
              trainClassId: this.$route.query.tsId,
              courseId: courseId,
              userId: sessionStorage.userUuid,
              createTime: createTime,
              seatMealCourseId: mealId
            })
          )
          .then(res => {
            if (res.code === '200') {
              this.$set(this.subRecordList, index, res.data)
            }
          })
      } else {
        this.showRecord[index] = this.$set(this.showRecord, index, false)
      }
    },
    handleNoteClose () {
      this.checkAll = false
    },
    handleSuggestionClose () {
      this.imageUrl.length=0;
      this.remain = 0;
      this.$refs['suggestion_form'].resetFields();
    }
  }
}
</script>
<style lang="scss">
@import "./classSoftware.scss";
.el-radio-group {
    display: flex;
    flex-wrap: wrap;
    .el-radio{
        margin: 10px 10px 0 0;
        width: 98px;
        text-align: center;
    }
    .el-radio.is-bordered+.el-radio.is-bordered {
        margin-left: 0;
    }
}
.list-wrap {
    margin-top: 30px;
    .course-wrap {
        display:flex;
        justify-content:space-around;
        align-items: center;
        height: 50px;
        .study-long {
            width:220px;
        }
        .study-time {
            margin:0;
            width:100px;
            margin:0 30px;
        }
        .last-study {
            margin:0;
            flex:1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            &:hover {
                white-space:normal;
                overflow: visible;
            }
        }
        .study-detail {
            margin:0;
            margin-left:30px;
            cursor:pointer;
            width:100px;
        }
        .study-time, .study-long, .last-study, .study-detail {
            color:#333333;
        }
    }
    .record-detail {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 12px;
        margin: 0 30px;
        color:#333333;
        .create-time {
            width: 200px;
        }
        .study-time {
            width: 300px;
        }
        .section-name {
            width: 350px;
        }
        .nowrap-one{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}
.study-progress {
    position: relative;
    .pre-number {
        position: absolute;
        left: 155px;
        font-size: 12px;
    }
}
.contentBox{
    .el-icon-back {
        cursor: pointer;
        width: 22px;
        height: 22px;
        margin-right: 8px;
        border-radius: 11px;
        color: #fff;
        text-align: center;
        line-height: 22px;
        background: #3688d6;
        position: absolute;
        left: 35px;
        top: 15px;
    }
}
.courseTypeImg{
    height:20px;
    width:68px;
    position: absolute;
    top: 0;
    right: 0;
}
.learning-system h2 {
    text-align: center;
    margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/trainClass/personalCenter/learnCenter/classSoftware.vue